import React, { useEffect, useState } from "react";
import { Chart } from "primereact/chart";
import { Chart as Chart2, registerables } from "chart.js";
import {
  ChoroplethController,
  GeoFeature,
  ColorScale,
  ProjectionScale,
} from "chartjs-chart-geo";
import * as ChartGeo from "chartjs-chart-geo";
import {
  getCostSavingsSummary,
  getLeadTimeSummary,
  getProcurementDashboard,
  getPurchaseOrderSummary,
  getTopPurchaseItemsSummary,
  getTopSpendAreasSummary,
  getTopVendorsSummary,
  getVendorAveragePerformanceSummary,
} from "../../../../../services/inventory/procurement/procurementReportService";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchFiscalYear from "../../../setup/finance/searchFiscalYear";
import SearchFiscalPeriod from "../../../setup/finance/searchFiscalPeriod";
import { DialogActions, IconButton, Typography } from "@material-ui/core";
import { Search } from "@mui/icons-material";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { abbrMonthName, abbrNum } from "../../../../../utils/utils";
import { DateTime } from "luxon";
import _ from "lodash";

// register controller in chart.js and ensure the defaults are set
Chart2.register(ChoroplethController, GeoFeature, ColorScale, ProjectionScale);
Chart2.register(...registerables);

function ProcurementDashboard(props) {
  const {
    companyProfile,
    currentFiscalYear,
    currentFiscalPeriod,
    reload,
  } = useGlobalData();
  const [
    openSearchFiscalYearPurchaseOrder,
    setOpenSearchFiscalYearPurchaseOrder,
  ] = useState(false);
  const [
    openSearchFiscalYearLeadTime,
    setOpenSearchFiscalYearLeadTime,
  ] = useState(false);
  const [
    openSearchFiscalYearCostSavings,
    setOpenSearchFiscalYearCostSavings,
  ] = useState(false);
  const [
    openSearchFiscalYearVendorAveragePerformance,
    setOpenSearchFiscalYearVendorAveragePerformance,
  ] = useState(false);
  const [openSearchFiscalYear, setOpenSearchFiscalYear] = useState(false);
  const [
    openSearchFiscalPeriodTopVendors,
    setOpenSearchFiscalPeriodTopVendors,
  ] = useState(false);
  const [
    openSearchFiscalPeriodTopPurchaseItems,
    setOpenSearchFiscalPeriodTopPurchaseItems,
  ] = useState(false);
  const [
    openSearchFiscalPeriodTopSpendAreas,
    setOpenSearchFiscalPeriodTopSpendAreas,
  ] = useState(false);
  const [openSearchFiscalPeriod, setOpenSearchFiscalPeriod] = useState(false);
  const [fiscalYearPurchaseOrder, setFiscalYearPurchaseOrder] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalYearLeadTime, setFiscalYearLeadTime] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalYearCostSavings, setFiscalYearCostSavings] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [
    fiscalYearVendorAveragePerformance,
    setFiscalYearVendorAveragePerformance,
  ] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalPeriodTopVendors, setFiscalPeriodTopVendors] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [
    fiscalPeriodTopPurchaseItems,
    setFiscalPeriodTopPurchaseItems,
  ] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [fiscalPeriodTopSpendAreas, setFiscalPeriodTopSpendAreas] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [totalPurchases, setTotalPurchases] = useState(0);
  const [totalVendors, setTotalVendors] = useState(0);
  const [totalAverageOnTimeSupplies, setTotalAverageOnTimeSupplies] = useState(
    0
  );
  const [totalAverageLeadTime, setTotalAverageLeadTime] = useState(0);

  const [purchaseOrderSummaryAmount, setPurchaseOrderSummaryAmount] = useState({
    totalPurchases: 0,
    totalOrders: 0,
    totalRequests: 0,
  });
  const [purchaseOrderSummaryData, setPurchaseOrderSummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "Purchases",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Orders",
        borderColor: "#0096ec",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Requests",
        borderColor: "#6610f2",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const purchaseOrderSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [leadTimeSummaryData, setLeadTimeSummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "bar",
        label: "Goods Received",
        backgroundColor: "#12b18c",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
      {
        type: "bar",
        label: "Invoicing",
        backgroundColor: "#0096ec",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
      {
        type: "bar",
        label: "Payment",
        backgroundColor: "#6610f2",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
    ],
  });

  const leadTimeSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `Average ${tooltipItem.dataset.label}: ${tooltipItem.formattedValue} Days`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        stacked: true,
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [topVendorsSummaryData, setTopVendorsSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topVendorsSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topVendorsSummaryPlugins = {
    id: "topVendorsSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topVendorsSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [
    topPurchaseItemsSummaryData,
    setTopPurchaseItemsSummaryData,
  ] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topPurchaseItemsSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topPurchaseItemsSummaryPlugins = {
    id: "topPurchaseItemsSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topPurchaseItemsSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [topSpendAreasSummaryData, setTopSpendAreasSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topSpendAreasSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topSpendAreasSummaryPlugins = {
    id: "topSpendAreasSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topSpendAreasSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [costSavingsSummaryData, setCostSavingsSummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "Cost Savings",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Cost Reduction",
        borderColor: "#0096ec",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const costSavingsSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 2.2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [
    vendorAveragePerformanceSummaryData,
    setVendorAveragePerformanceSummaryData,
  ] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "Availability",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "On-Time Supply",
        borderColor: "#0096ec",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Defect",
        borderColor: "#fd7e14",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Return",
        borderColor: "#f1416c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const vendorAveragePerformanceSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 2.2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}%`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  async function purchaseByCountriesSummaryData(purchaseByCountries = []) {
    let canvas = document.getElementById("canvasPurchaseByCountries");
    if (!canvas) return;

    fetch("https://unpkg.com/world-atlas@2.0.2/countries-50m.json")
      .then((result) => result.json())
      .then((datapoint) => {
        const countries = ChartGeo.topojson.feature(
          datapoint,
          datapoint.objects.countries
        ).features;

        if (chart) {
          chart.destroy();
        }

        let countryData = [];
        countries.map((country) => {
          const countryValue = _.find(purchaseByCountries, [
            "countryName",
            country.properties.name,
          ]);

          if (countryValue && countryValue.purchaseAmount > 0) {
            countryData.push({
              feature: country,
              value: countryValue.purchaseAmount,
            });
          } else {
            countryData.push({
              feature: country,
              value: 0,
            });
          }
        });

        const chart = new Chart2(canvas.getContext("2d"), {
          type: "choropleth",
          data: {
            labels: countries.map((country) => country.properties.name),
            datasets: [
              {
                label: "Countries",
                //outline: nation,
                data: countryData,
              },
            ],
          },
          options: {
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                callbacks: {
                  label: function(tooltipItem, data, value) {
                    return `${
                      tooltipItem.dataset.data[tooltipItem.dataIndex].feature
                        .properties.name
                    }: ${companyProfile.currency.currencyCode} ${
                      tooltipItem.formattedValue
                    }`;
                  },
                },
                usePointStyle: true,
              },
            },
            scales: {
              xy: { projection: "equalEarth" },
              color: {
                axis: "x",
                quantize: 5,
                ticks: {
                  color: "#6c7293",
                  callback: (value, index, values) => {
                    return abbrNum(value, 2);
                  },
                },
                legend: {
                  position: "bottom-left",
                },
              },
            },
          },
        });

        return () => {
          chart.destroy();
        };
      });
  }

  async function getProcurementDashboardData(
    fiscalYearID = 0,
    fiscalPeriodID = 0
  ) {
    const response = await getProcurementDashboard(
      fiscalYearID,
      fiscalPeriodID
    );
    const { data } = response.data;
    const {
      totalPurchases,
      totalVendors,
      totalAverageOnTimeSupplies,
      totalAverageLeadTime,
      purchaseOrderSummary,
      leadTimeSummary,
      topVendorsSummary,
      topPurchaseItemsSummary,
      topSpendAreasSummary,
      costSavingsSummary,
      vendorAveragePerformanceSummary,
      purchaseByCountriesSummary,
    } = data;
    setTotalPurchases(totalPurchases);
    setTotalVendors(totalVendors);
    setTotalAverageOnTimeSupplies(totalAverageOnTimeSupplies);
    setTotalAverageLeadTime(totalAverageLeadTime);
    setPurchaseOrderSummaryData(purchaseOrderSummary.datasets);
    setPurchaseOrderSummaryAmount({
      totalPurchases: purchaseOrderSummary.totalPurchases,
      totalOrders: purchaseOrderSummary.totalOrders,
      totalRequests: purchaseOrderSummary.totalRequests,
    });
    setLeadTimeSummaryData(leadTimeSummary.datasets);
    setTopVendorsSummaryData(topVendorsSummary.datasets);
    setTopPurchaseItemsSummaryData(topPurchaseItemsSummary.datasets);
    setTopSpendAreasSummaryData(topSpendAreasSummary.datasets);
    setCostSavingsSummaryData(costSavingsSummary.datasets);
    setVendorAveragePerformanceSummaryData(
      vendorAveragePerformanceSummary.datasets
    );
    purchaseByCountriesSummaryData(purchaseByCountriesSummary.datasets);
  }

  async function getPurchaseOrderSummaryData(fiscalYearID = 0) {
    const response = await getPurchaseOrderSummary(fiscalYearID);
    const { data } = response.data;
    setPurchaseOrderSummaryData(data.purchaseOrderSummary);
    setPurchaseOrderSummaryAmount({
      totalPurchases: data.totalPurchases,
      totalOrders: data.totalOrders,
      totalRequests: data.totalRequests,
    });
  }

  async function getLeadTimeSummaryData(fiscalYearID = 0) {
    const response = await getLeadTimeSummary(fiscalYearID);
    const { data } = response.data;
    setLeadTimeSummaryData(data.leadTimeSummary);
  }

  async function getTopVendorsSummaryData(fiscalPeriodID = 0) {
    const response = await getTopVendorsSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopVendorsSummaryData(data.topVendorsSummary);
  }

  async function getTopPurchaseItemsSummaryData(fiscalPeriodID = 0) {
    const response = await getTopPurchaseItemsSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopPurchaseItemsSummaryData(data.topPurchaseItemsSummary);
  }

  async function getTopSpendAreasSummaryData(fiscalPeriodID = 0) {
    const response = await getTopSpendAreasSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopSpendAreasSummaryData(data.topSpendAreasSummary);
  }

  async function getCostSavingsSummaryData(fiscalYearID = 0) {
    const response = await getCostSavingsSummary(fiscalYearID);
    const { data } = response.data;
    setCostSavingsSummaryData(data.costSavingsSummary);
  }

  async function getVendorAveragePerformanceSummaryData(fiscalYearID = 0) {
    const response = await getVendorAveragePerformanceSummary(fiscalYearID);
    const { data } = response.data;
    setVendorAveragePerformanceSummaryData(
      data.vendorAveragePerformanceSummary
    );
  }

  useEffect(() => {
    getProcurementDashboardData(currentFiscalYear.ID, currentFiscalPeriod.ID);
  }, [reload]);

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-shopping-cart" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Purchases
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {companyProfile.currency.currencyCode}{" "}
                      {abbrNum(totalPurchases, 2)}
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    <Typography className="kt-font-bold text-danger">
                      <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                      10%
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-handshake" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Vendors
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {abbrNum(totalVendors, 0)}
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    <Typography className="kt-font-bold text-success">
                      <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                      1%
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-clock" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      On-Time Supplies
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {abbrNum(totalAverageOnTimeSupplies, 2)}%
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    <Typography className="kt-font-bold text-danger">
                      <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                      3%
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-stopwatch" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Average Lead Time
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {abbrNum(totalAverageLeadTime, 0)} Days
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    <Typography className="kt-font-bold text-success">
                      <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                      1%
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Purchase Order Overview
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(
                            fiscalYearPurchaseOrder.startMonthName
                          ) +
                            " " +
                            fiscalYearPurchaseOrder.year +
                            " - " +
                            abbrMonthName(
                              fiscalYearPurchaseOrder.endMonthName
                            ) +
                            " " +
                            fiscalYearPurchaseOrder.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearPurchaseOrder(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-9 col-lg-9">
                <Chart
                  type="bar"
                  data={purchaseOrderSummaryData}
                  options={purchaseOrderSummaryOptions}
                  style={{ minHeight: "250px" }}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3 p-0">
                <div className="column">
                  <div className="col-sm-12 col-md-12 col-lg-12 pl-md-0">
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Purchases
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(
                            purchaseOrderSummaryAmount.totalPurchases,
                            2
                          )}
                        </Typography>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Orders
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(purchaseOrderSummaryAmount.totalOrders, 2)}
                        </Typography>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Requests
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(purchaseOrderSummaryAmount.totalRequests, 2)}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Lead Time Analysis
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalYearLeadTime.startMonthName) +
                            " " +
                            fiscalYearLeadTime.year +
                            " - " +
                            abbrMonthName(fiscalYearLeadTime.endMonthName) +
                            " " +
                            fiscalYearLeadTime.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearLeadTime(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="bar"
                  data={leadTimeSummaryData}
                  options={leadTimeSummaryOptions}
                  style={{ minHeight: "250px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Top 5 Vendors
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalPeriodTopVendors.monthName) +
                            " " +
                            fiscalPeriodTopVendors.year}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriodTopVendors(true);
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={topVendorsSummaryData}
                  options={topVendorsSummaryOptions}
                  plugins={[topVendorsSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Top 5 Purchase Items
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(
                            fiscalPeriodTopPurchaseItems.monthName
                          ) +
                            " " +
                            fiscalPeriodTopPurchaseItems.year}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriodTopPurchaseItems(true);
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={topPurchaseItemsSummaryData}
                  options={topPurchaseItemsSummaryOptions}
                  plugins={[topPurchaseItemsSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Top 5 Spend Areas
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalPeriodTopSpendAreas.monthName) +
                            " " +
                            fiscalPeriodTopSpendAreas.year}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriodTopSpendAreas(true);
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={topSpendAreasSummaryData}
                  options={topSpendAreasSummaryOptions}
                  plugins={[topSpendAreasSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Cost Savings
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalYearCostSavings.startMonthName) +
                            " " +
                            fiscalYearCostSavings.year +
                            " - " +
                            abbrMonthName(fiscalYearCostSavings.endMonthName) +
                            " " +
                            fiscalYearCostSavings.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearCostSavings(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="bar"
                  data={costSavingsSummaryData}
                  options={costSavingsSummaryOptions}
                  style={{ minHeight: "180px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Vendor Average Performance
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(
                            fiscalYearVendorAveragePerformance.startMonthName
                          ) +
                            " " +
                            fiscalYearVendorAveragePerformance.year +
                            " - " +
                            abbrMonthName(
                              fiscalYearVendorAveragePerformance.endMonthName
                            ) +
                            " " +
                            fiscalYearVendorAveragePerformance.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearVendorAveragePerformance(
                                true
                              );
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="bar"
                  data={vendorAveragePerformanceSummaryData}
                  options={vendorAveragePerformanceSummaryOptions}
                  style={{ minHeight: "180px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Purchase By Countries
                </Typography>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <canvas id="canvasPurchaseByCountries"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSearchFiscalYear}
        title="Search Fiscal Year"
        onCloseDialog={() => {
          setOpenSearchFiscalYear(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalYear
          onSelectFiscalYear={(fiscalYear) => {
            if (openSearchFiscalYearPurchaseOrder) {
              setFiscalYearPurchaseOrder({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearPurchaseOrder(false);
              getPurchaseOrderSummaryData(fiscalYear.ID);
            } else if (openSearchFiscalYearLeadTime) {
              setFiscalYearLeadTime({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearLeadTime(false);
              getLeadTimeSummaryData(fiscalYear.ID);
            } else if (openSearchFiscalYearCostSavings) {
              setFiscalYearCostSavings({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearCostSavings(false);
              getCostSavingsSummaryData(fiscalYear.ID);
            } else if (openSearchFiscalYearVendorAveragePerformance) {
              setFiscalYearVendorAveragePerformance({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearVendorAveragePerformance(false);
              getVendorAveragePerformanceSummaryData(fiscalYear.ID);
            }
            setOpenSearchFiscalYear(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalYear(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchFiscalPeriod}
        title="Search Fiscal Period"
        onCloseDialog={() => {
          setOpenSearchFiscalPeriod(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalPeriod
          onSelectFiscalPeriod={(fiscalPeriod) => {
            if (openSearchFiscalPeriodTopVendors) {
              setFiscalPeriodTopVendors({
                ID: fiscalPeriod.ID,
                fiscalYearID: fiscalPeriod.fiscalYearID,
                year: fiscalPeriod.year,
                month: fiscalPeriod.month,
                monthName: fiscalPeriod.monthName,
                statusID: fiscalPeriod.statusID,
              });
              setOpenSearchFiscalPeriodTopVendors(false);
              getTopVendorsSummaryData(fiscalPeriod.ID);
            } else if (openSearchFiscalPeriodTopPurchaseItems) {
              setFiscalPeriodTopPurchaseItems({
                ID: fiscalPeriod.ID,
                fiscalYearID: fiscalPeriod.fiscalYearID,
                year: fiscalPeriod.year,
                month: fiscalPeriod.month,
                monthName: fiscalPeriod.monthName,
                statusID: fiscalPeriod.statusID,
              });
              setOpenSearchFiscalPeriodTopPurchaseItems(false);
              getTopPurchaseItemsSummaryData(fiscalPeriod.ID);
            } else if (openSearchFiscalPeriodTopSpendAreas) {
              setFiscalPeriodTopSpendAreas({
                ID: fiscalPeriod.ID,
                fiscalYearID: fiscalPeriod.fiscalYearID,
                year: fiscalPeriod.year,
                month: fiscalPeriod.month,
                monthName: fiscalPeriod.monthName,
                statusID: fiscalPeriod.statusID,
              });
              setOpenSearchFiscalPeriodTopSpendAreas(false);
              getTopSpendAreasSummaryData(fiscalPeriod.ID);
            }
            setOpenSearchFiscalPeriod(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalPeriod(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default ProcurementDashboard;
